export default "__VITE_ASSET__BpXveyfa__"